import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, NavigationCancel } from '@angular/router';
import { cloneDeep, flatten } from 'lodash';
import { FeatureProvider } from './feature.provider';
import { TokenState } from '../token/token.state';
import { FeatureCanActivate } from './feature.guard';
import { filter } from 'rxjs/operators';

@Injectable()
export class NavigationProvider {
  private navigations: any[];
  private navigationsObservable: BehaviorSubject<any[]>;
  private lastCancelledNavigationUrl: string;
  private lastCancelledNavigationUrlCustom: string;
  private lastCancelledNavigationQueryParams: any = {};
  private tokenStateObservable: BehaviorSubject<string>;

  constructor(
    private featureProvider: FeatureProvider,
    private tokenState: TokenState,
    private router: Router,
    private featureCanActivate: FeatureCanActivate) {
    this.lastCancelledNavigationUrl = '';
    this.navigationsObservable = new BehaviorSubject([]);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationCancel) {
        this.lastCancelledNavigationUrl = event.url;
      }
    });
    this.tokenStateObservable = this.tokenState.getTokenStateObservable();
    this.tokenStateObservable.subscribe(val => {
      if (val !== 'initial') {
        this.assignNavigationsVisibility();
      }
    });
  }

  public setCustomLastCancelledNavigation(redirecUrl: string, queryParams?: any) {
    this.lastCancelledNavigationUrlCustom = redirecUrl;
    this.lastCancelledNavigationQueryParams = queryParams || {};
  }
  public gettCustomLastCancelledNavigation(): string {
    const tempUrlForCustomRedirectNavigation = this.lastCancelledNavigationUrlCustom;
    this.lastCancelledNavigationUrlCustom = '';
    return tempUrlForCustomRedirectNavigation;
  }

  public getCurrentNavigationObserable() {
    return this.navigationsObservable;
  }

  public setCurrentNavigations(navigations) {
    this.navigations = navigations;
    this.navigationMaping();
  }

  public assignNavigationsVisibility() {
    this.featureCanActivate.featuresLoadEvent
      .pipe(filter((loadCompleted: boolean) => loadCompleted))
      .subscribe(() => {
        this.navigationMaping();
      });
  }

  private navigationMaping() {
    this.featureProvider.getFeatures().then((response: any) => {
      // const featuresFlatMap: string[] = response.map((element: any) => element.Name);
      const featuresFlatMap: string[] = flatten(response.map((element: any) => {
        const featureList = [element.Name];
        if (element.Features && element.Features.length) {
          element.Features.forEach(feature => { featureList.push(`${element.Name}.${feature}`); });
        }
        return featureList;
      }));

      const distinctFeatures = featuresFlatMap.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });

      let clonedNavigations = cloneDeep(this.navigations);
      this.filterNavigations(clonedNavigations, distinctFeatures);
      this.modifiedNavigation(clonedNavigations);
      this.navigationsObservable.next(clonedNavigations);
    });
  }

  public filterNavigations(navigations: any[], featuresFlatMap: any[]) {
    if (!navigations) return;

    const navLength = navigations.length;

    for (let index = 0; index < navLength; index++) {
      let navigation = navigations[index];

      if (navigation.type === 'collapsable' || navigation.type === 'group') {
        if (featuresFlatMap.indexOf(navigation.id) === -1) {
          navigation.isShown = false;
          navigation.children.map(n => n.isShown = false);
        } else {
          this.filterNavigations(navigation.children, featuresFlatMap);
          if (navigation.hasOwnProperty('isVisible'))
            navigation.isShown = navigation.isVisible;
          else
            navigation.isShown = true;
        }
      } else if (featuresFlatMap.indexOf(navigation.id) === -1) {
        navigation.isShown = false;
      } else {
        if (navigation.hasOwnProperty('isVisible'))
          navigation.isShown = navigation.isVisible;
        else
          navigation.isShown = true;
      }
    }
  }

  private modifiedNavigation(navigations: any[]) {
    if (!navigations) return;

    const navLength = navigations.length;
    for (let index = 0; index < navLength; index++) {
      const navigation = navigations[index];
      if (navigation.isShown && (navigation.type === 'collapsable' || navigation.type === 'group')) {
        const childs = navigation.children.filter((child: any) => child.isShown);
        if (childs.length)
          navigation.children = childs;
        else
          navigation.isShown = false;
      }
    }

    navigations = navigations.filter((item: any) => item.isShown);
  }

  public getApps() {
    return this.navigations;
  }

  public getLastCancelledNavigation(): string {
    const tempUrl = this.lastCancelledNavigationUrl;
    this.lastCancelledNavigationUrl = '';
    return tempUrl;
  }

  public getLastCancelledNavigationQueryParams(): any {
    const queryParam = this.lastCancelledNavigationQueryParams;
    this.lastCancelledNavigationQueryParams = {};
    return queryParam;
  }

  public resetLastCancelledNavigation() {
    this.lastCancelledNavigationUrl = '';
  }

}
